import {
  FormControl,
  FormLabel,
  Select,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  name: string;
  value: any;
  handleChange: any;
  disabled?: boolean;
  title?: string;
  isRequiredFalse?: boolean;
  data: any | [];
  isFromApi?: boolean;
  allEle?: boolean;
  width?:string
}
const CustomSelect: React.FC<Props> = ({
  disabled,
  handleChange,
  name,
  value,
  title,
  isRequiredFalse,
  data,
  isFromApi,
  allEle,
  width
}) => {
  const { t } = useTranslation();
  const textColor = useColorModeValue("navy.700", "white");
  return (
    <>
      <FormControl isRequired={isRequiredFalse ? false : true} width={width??"100%"}>
        {title && (
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            {title}
          </FormLabel>
        )}
        <Select
          fontSize="sm"
          id="currency"
          variant="main"
          h="44px"
          maxH="44px"
          me="20px"
          // mb="24px"
          disabled={disabled}
          name={name}
          value={value}
          onChange={handleChange}
          sx={{ color: textColor,  }}
          // width={200}
        >
          <option selected>{t("common.text.select")}</option>
          {data?.map((ele: any) => {
            return (
              <option key={ele._id} value={allEle ? ele : ele._id}>
                {isFromApi ? <>{ele.title}</> : <>{t(ele.value)}</>}
              </option>
            );
          })}
        </Select>
      </FormControl>
    </>
  );
};

export default CustomSelect;
